import { SearchObject } from "app/common/Model/SearchObject";
import { searchDrugOrderReport } from "app/services/DrugService";
import { pagingReportParticipants, exportExcelMonneyTour } from "app/services/EncounterParticipantService";
import { exportReportDrugItem } from "app/services/VoucherService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportMonneyTourStore {
  listDataReportParticipants = null;
  sumDataReport = null;

  searchReportParticipants = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentIds: [],
    performerId: null,
    itemStatus: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchReportParticipants = (searchReportParticipants) => {
    this.searchReportParticipants = {
      ...this.searchReportParticipants,
      ...searchReportParticipants,
    };
    this.pagingReportParticipants();
  };

  pagingReportParticipants = async () => {
    try {
      // Không call API nếu không có cơ sở (bắt buộc)
      if (!this.searchReportParticipants.departmentIds || this.searchReportParticipants.departmentIds.length === 0) {
        this.listDataReportParticipants = null;
        this.sumDataReport = null;
        return;
      }
      
      let { departmentIds, performerId, ...otherData } = this.searchReportParticipants;
      if (this.searchReportParticipants?.departmentIds) {
        otherData.departmentIds =
          this.searchReportParticipants?.departmentIds?.map((x) => x.id) || [];
      }
      otherData.performerId =
        this.searchReportParticipants?.performer?.id ||
        this.searchReportParticipants?.performerId ||
        null;

      const { data } = await pagingReportParticipants({ ...otherData })
      this.listDataReportParticipants = data;
      this.getTotalWageParticipants();
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  handleExportExcelMonneyTour = async () => {
    if (!this.searchReportParticipants.departmentIds || this.searchReportParticipants.departmentIds.length === 0) {
      toast.warning("Vui lòng chọn cơ sở trước khi xuất excel");
      return;
    }
    
    let { departmentIds, performerId, ...otherData } = this.searchReportParticipants;
    if (this.searchReportParticipants?.departmentIds) {
      otherData.departmentIds =
        this.searchReportParticipants?.departmentIds?.map((x) => x.id) || [];
    }
    otherData.performerId =
      this.searchReportParticipants?.performer?.id ||
      this.searchReportParticipants?.performerId ||
      null;

    try {
      const response = await exportExcelMonneyTour(otherData);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BAO_CAO_TIEN_TOUR.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
      toast.error("Có lỗi xảy ra khi xuất Excel");
    }
  };

  // chỉ lấy tổng
  getTotalWageParticipants = async () => {
    try {
      // Không call API nếu không có cơ sở (bắt buộc)
      if (!this.searchReportParticipants.departmentIds || this.searchReportParticipants.departmentIds.length === 0) {
        this.sumDataReport = null;
        return;
      }
      
      let { departmentIds, performerId, ...otherData } = this.searchReportParticipants;
      otherData.getTotalWage = true;
      otherData.getPaging = false;
      if (this.searchReportParticipants?.departmentIds) {
        otherData.departmentIds =
          this.searchReportParticipants?.departmentIds?.map((x) => x.id) || [];
      }
      otherData.performerId =
        this.searchReportParticipants?.performer?.id ||
        this.searchReportParticipants?.performerId ||
        null;
      const { data } = await pagingReportParticipants({ ...otherData });
      this.sumDataReport = data;

    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu tổng có lỗi");
    }
  };



  resetStore = () => {
    this.listDataReportParticipants = null;
    this.sumDataReport = null;
    this.searchReportParticipants = new SearchObject();
  };


}
